import { useContext, useEffect } from 'react';

import { getEnabledSystemFeatures, SystemFeatures } from '../api/Feature';
import { AppContext } from '../context/AppContext';
import featureIsEnabled from '../utils/featureIsEnabled';

const useSystemFeatures = () => {
  const {
    systemFeatures,
    setSystemFeatures,
    setShowSimulationMode,
    setShowTariffRecommender,
    setSubscriptionsDisabled,
  } = useContext(AppContext);

  useEffect(() => {
    void getEnabledSystemFeatures().then((systemFeatures) => setSystemFeatures(systemFeatures?.enabled_features));
  }, []);

  useEffect(() => {
    const showSimulationMode = featureIsEnabled(systemFeatures, SystemFeatures.OPTIMISE_SIMULATION_USERS);
    setShowSimulationMode(showSimulationMode);
  }, [systemFeatures]);

  useEffect(() => {
    const showTariffRecommender = featureIsEnabled(systemFeatures, SystemFeatures.TARIFF_SIM);
    setShowTariffRecommender(showTariffRecommender);
  }, [systemFeatures, setShowTariffRecommender]);

  useEffect(() => {
    const subscriptionsDisabled = featureIsEnabled(systemFeatures, SystemFeatures.USER_SUBS_DISABLED);
    setSubscriptionsDisabled(subscriptionsDisabled);
  }, [systemFeatures, setSubscriptionsDisabled]);
};

export default useSystemFeatures;
